import getDataFromStorage from 'util/getDataFromStorage';

const auth = getDataFromStorage('auth_data');
const accessToken = localStorage.getItem('auth_accesstoken');
const refreshToken = localStorage.getItem('auth_refreshtoken');
const user = auth.user || {};
const currentCollaborator = localStorage.getItem('current_collaborator');

export const authInitialState = {
  ...auth,
  user,
  claims: user.claims || [],
  permissions: user.permissions || [],
  expirationDate: auth.expirationDate ? new Date(auth.expirationDate) : null,
  refreshToken,
  accessToken,
  currentCollaborator: currentCollaborator
    ? JSON.parse(currentCollaborator)
    : null
};
